/** The 32 NFL rosters managers pick from, plus the aliases the workbook and
 * Discord actually use ("Bucs", "SF", "49ers", "Min") so imports resolve. */
export const NFL_TEAMS = [
    { abbr: "ARI", city: "Arizona", name: "Cardinals", conference: "NFC", aliases: ["cardinals", "cards", "az"] },
    { abbr: "ATL", city: "Atlanta", name: "Falcons", conference: "NFC", aliases: ["falcons"] },
    { abbr: "BAL", city: "Baltimore", name: "Ravens", conference: "AFC", aliases: ["ravens"] },
    { abbr: "BUF", city: "Buffalo", name: "Bills", conference: "AFC", aliases: ["bills"] },
    { abbr: "CAR", city: "Carolina", name: "Panthers", conference: "NFC", aliases: ["panthers"] },
    { abbr: "CHI", city: "Chicago", name: "Bears", conference: "NFC", aliases: ["bears"] },
    { abbr: "CIN", city: "Cincinnati", name: "Bengals", conference: "AFC", aliases: ["bengals"] },
    { abbr: "CLE", city: "Cleveland", name: "Browns", conference: "AFC", aliases: ["browns"] },
    { abbr: "DAL", city: "Dallas", name: "Cowboys", conference: "NFC", aliases: ["cowboys"] },
    { abbr: "DEN", city: "Denver", name: "Broncos", conference: "AFC", aliases: ["broncos"] },
    { abbr: "DET", city: "Detroit", name: "Lions", conference: "NFC", aliases: ["lions", "detroit"] },
    { abbr: "GB", city: "Green Bay", name: "Packers", conference: "NFC", aliases: ["packers", "greenbay", "gnb"] },
    { abbr: "HOU", city: "Houston", name: "Texans", conference: "AFC", aliases: ["texans"] },
    { abbr: "IND", city: "Indianapolis", name: "Colts", conference: "AFC", aliases: ["colts"] },
    { abbr: "JAX", city: "Jacksonville", name: "Jaguars", conference: "AFC", aliases: ["jaguars", "jags", "jac"] },
    { abbr: "KC", city: "Kansas City", name: "Chiefs", conference: "AFC", aliases: ["chiefs", "kansascity", "kan"] },
    { abbr: "LAC", city: "Los Angeles", name: "Chargers", conference: "AFC", aliases: ["chargers", "sd"] },
    { abbr: "LAR", city: "Los Angeles", name: "Rams", conference: "NFC", aliases: ["rams", "la", "stl"] },
    { abbr: "LV", city: "Las Vegas", name: "Raiders", conference: "AFC", aliases: ["raiders", "oak", "lvr"] },
    { abbr: "MIA", city: "Miami", name: "Dolphins", conference: "AFC", aliases: ["dolphins", "fins"] },
    { abbr: "MIN", city: "Minnesota", name: "Vikings", conference: "NFC", aliases: ["vikings", "vikes", "min"] },
    { abbr: "NE", city: "New England", name: "Patriots", conference: "AFC", aliases: ["patriots", "pats", "nwe"] },
    { abbr: "NO", city: "New Orleans", name: "Saints", conference: "NFC", aliases: ["saints", "nor"] },
    { abbr: "NYG", city: "New York", name: "Giants", conference: "NFC", aliases: ["giants"] },
    { abbr: "NYJ", city: "New York", name: "Jets", conference: "AFC", aliases: ["jets"] },
    { abbr: "PHI", city: "Philadelphia", name: "Eagles", conference: "NFC", aliases: ["eagles"] },
    { abbr: "PIT", city: "Pittsburgh", name: "Steelers", conference: "AFC", aliases: ["steelers"] },
    { abbr: "SEA", city: "Seattle", name: "Seahawks", conference: "NFC", aliases: ["seahawks", "hawks"] },
    { abbr: "SF", city: "San Francisco", name: "49ers", conference: "NFC", aliases: ["49ers", "niners", "sfo", "sanfrancisco"] },
    { abbr: "TB", city: "Tampa Bay", name: "Buccaneers", conference: "NFC", aliases: ["bucs", "buccaneers", "tampabay", "tam"] },
    { abbr: "TEN", city: "Tennessee", name: "Titans", conference: "AFC", aliases: ["titans"] },
    { abbr: "WAS", city: "Washington", name: "Commanders", conference: "NFC", aliases: ["commanders", "wsh", "washington"] },
];
const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, "");
const LOOKUP = new Map();
for (const t of NFL_TEAMS) {
    for (const key of [t.abbr, t.name, `${t.city} ${t.name}`, ...t.aliases]) {
        LOOKUP.set(norm(key), t);
    }
}
/** Resolve whatever the sheet or a manager typed to a canonical team. */
export function resolveTeam(input) {
    if (!input)
        return null;
    return LOOKUP.get(norm(input)) ?? null;
}
export function teamLabel(t) {
    return `${t.city} ${t.name}`;
}
//# sourceMappingURL=teams.js.map